// extracted by mini-css-extract-plugin
export default {"tableWrapper":"ConsultationNoteTemplatesTable_tableWrapper__zAxY5"};